// Auto-generated client configuration - DO NOT EDIT MANUALLY
// Generated by frontend/scripts/prepare-client.js from clients/{CLIENT_ID}/config.json.
// This file is regenerated at every build and is gitignored.

export const CLIENT_CONFIG = {
  "client_id": "heesen",
  "auth": {},
  "languages": [
    "nl",
    "en"
  ],
  "theme": {
    "name": "Heesen Yachts",
    "colors": {
      "primary": "#0E1E3B",
      "secondary": "#0E1E3B",
      "accent": "#B98B71",
      "background": "#FFFFFF",
      "surface": "#DDE4EC",
      "text": {
        "primary": "#0E1E3B",
        "secondary": "#4C5B75",
        "muted": "#6E7C94"
      },
      "success": "#38A169",
      "warning": "#D69E2E",
      "error": "#E53E3E",
      "tint": "#DDE4EC"
    },
    "branding": {
      "logoUrl": "/assets/heesen/logo.svg",
      "showLogoInHeader": true,
      "logoHeight": "36px",
      "logoDarkModeUrl": "/assets/heesen/logo-dark.svg",
      "faviconUrl": "/assets/heesen/favicon.ico",
      "agentIconUrl": "/assets/heesen/agentIcon.png",
      "internalIconUrl": "/assets/heesen/internalIcon.png",
      "companyName": "Heesen Yachts",
      "assistantName": "H/AI",
      "tagline": "AI Assistant",
      "supportEmail": "",
      "backgroundImage": "/assets/heesen/background.webp"
    },
    "typography": {
      "fontFamily": "'Work Sans', system-ui, sans-serif",
      "headingFontFamily": "'Work Sans', system-ui, sans-serif",
      "googleFontsUrl": "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,300..700;1,300..700&display=swap"
    },
    "layout": {
      "sidebarWidth": "300px",
      "headerHeight": "72px",
      "borderRadius": "4px"
    },
    "customTexts": {
      "welcomeMessage": "Welcome to the Heesen Yachts AI Assistant",
      "chatPlaceholder": "Ask me anything...",
      "footerText": "Heesen Yachts - AI Assistant",
      "thinkingMessages": {
        "en": [
          "Reading the charts...",
          "Finding the right course...",
          "Checking the logbook..."
        ],
        "nl": [
          "De kaarten bestuderen...",
          "De juiste koers bepalen...",
          "Het logboek raadplegen..."
        ]
      },
      "vanillaAgent": {
        "exampleQuestions": [
          "Summarize this document for me.",
          "Help me draft an email to a supplier."
        ]
      }
    },
    "informationModal": {
      "en": {
        "title": "About the H/AI assistant",
        "intro": "Welcome to the H/AI assistant. It gives you powerful AI in a secure Heesen environment, so your questions, documents and answers stay within the company. Below you will find what the assistant can help you with and how to get the most out of it.",
        "sections": [
          {
            "heading": "What can the assistant help you with?",
            "items": [
              "The assistant can answer questions like the ones you would ask ChatGPT.",
              "The assistant has broad general knowledge, but does not know about current events such as the latest news.",
              "The assistant can answer questions based on a specific selection of internal information sources.",
              "You can upload documents and discuss them with the assistant, for example to summarize them or extract action points."
            ]
          },
          {
            "heading": "How to get the most out of the assistant",
            "items": [
              "Ask a clear question in full sentences. Single keywords often produce mediocre answers; a full sentence gives the assistant the context it needs to help you well.",
              "Within one conversation the assistant remembers what you said earlier, so you can ask follow-up questions. It does not understand what you mean if you refer to information from other conversations.",
              "Start a new conversation (button at the top left) when switching to a different topic, so answers stay sharp."
            ]
          }
        ],
        "notes": [
          "Note: this is an AI assistant, not an AI agent. It helps you with individual tasks when you ask, for example summarizing an email, but does not autonomously take follow-up actions like sending emails.",
          "Use the thumbs under an answer to give feedback. That helps make the assistant smarter."
        ]
      },
      "nl": {
        "title": "Over de H/AI assistent",
        "intro": "Welkom bij de H/AI assistent. Je krijgt krachtige AI in een beveiligde Heesen-omgeving, zodat je vragen, documenten en antwoorden binnen het bedrijf blijven. Hieronder lees je waar de assistent je mee kan helpen en hoe je er het beste uithaalt.",
        "sections": [
          {
            "heading": "Waar kan de assistent je mee helpen?",
            "items": [
              "De assistent kan vragen beantwoorden zoals je die aan ChatGPT zou stellen.",
              "De assistent heeft veel algemene kennis, maar weet niets van actualiteiten zoals het laatste nieuws.",
              "De assistent kan vragen beantwoorden op basis van een specifieke selectie aan interne informatiebronnen.",
              "Je kunt documenten uploaden en daar met de assistent over praten, bijvoorbeeld om ze samen te vatten of actiepunten op te halen."
            ]
          },
          {
            "heading": "Zo haal je het beste uit de assistent",
            "items": [
              "Stel een duidelijke vraag in volzinnen. Losse trefwoorden leveren vaak een matig antwoord op; een volledige zin geeft de assistent de context om je goed te helpen.",
              "Binnen één gesprek onthoudt de assistent wat je eerder hebt gezegd, zodat je vervolgvragen kunt stellen. Hij begrijpt echter niet wat je bedoelt als je verwijst naar informatie uit andere gesprekken.",
              "Begin een nieuw gesprek zodra je over een ander onderwerp wilt praten, dan blijven antwoorden scherp."
            ]
          }
        ],
        "notes": [
          "Let op: dit is een AI-assistent, geen AI-agent. Hij helpt je bij losse taken als je daarom vraagt, bijvoorbeeld een e-mail samenvatten, maar onderneemt niet zelfstandig vervolgacties zoals e-mails versturen.",
          "Gebruik de duimpjes onder een antwoord om feedback te geven. Daarmee help je de assistent slimmer te maken."
        ]
      }
    }
  }
};

export const CLIENT_ID = CLIENT_CONFIG.client_id;

export const IS_DEVELOPMENT = false;
